(function ($, Cobalt, undefined) {
    Cobalt.Countdown = {
        units: {
            y: 31536000,
            w: 604800,
            d: 86400,
            h: 3600,
            m: 60,
            s: 1,
        },
        initialize: function (callback) {
            $('.countdown').each(function () {
                var $this = $(this);
                var eTime = $this.attr('data-countdown-end');
                var format = $this.attr('data-countdown-format');
                var remaining = $this.attr('data-countdown-remaining');
                var diff = 0;

                if (remaining) {
                    remaining = parseInt(remaining);
                }

                var handleZero = function () {
                    clearInterval(interval);

                    if (callback) {
                        callback();
                    }
                }

                var interval = setInterval(function () {

                    if (eTime) {
                        var time = 0;
                        var now = new Date;
                        time = Math.floor(now / 1000);
                        diff = eTime - time;
                    }

                    // if we have remaining, use it instead trying to determine time left based on system time
                    if (remaining) {
                        diff = remaining--;
                    }

                    var removedTime = 0;
                    var text = format;

                    for (var unit in Cobalt.Countdown.units) {
                        if (Cobalt.Countdown.units.hasOwnProperty(unit)) {
                            if (text.indexOf('%' + unit) > -1) {
                                var multiplier = Cobalt.Countdown.units[unit];
                                var unitTime = Math.floor((diff - removedTime) / multiplier);

                                if (multiplier <= 60 && ('' + unitTime).length == 1) {
                                    unitTime = '0' + unitTime;
                                }

                                if (unitTime < 0) {
                                    unitTime = 0;
                                }

                                text = text.replace(new RegExp('%' + unit), unitTime);
                                removedTime += multiplier * unitTime;
                            }
                        }
                    }

                    $this.html(text);

                    if (remaining <= 0) {
                        handleZero();
                    }
                }, 1000);
            });
        }
    }
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Countdown.js